import {
  TouchableOpacity as ReactNativeButton,
  ViewStyle,
  TextStyle,
  StyleSheet,
} from 'react-native';
import React from 'react';
import {colors} from 'theme/Colors';
import LinearGradient from 'react-native-linear-gradient';
import {corner_radius, spacing} from 'theme/Units';
import {Text} from 'ui-kits';

type propType = Readonly<{
  title?: string;
  onPress?: () => void;
  disabled?: boolean;
  style?: ViewStyle;
  textStyle?: TextStyle;
  isBeta?: boolean;
  icon?: JSX.Element | null;
}>;
export function GradientButton(props: propType) {
  const {
    onPress,
    disabled,
    title,
    style: styleOverride,
    textStyle: textStyleOverride,
    icon,
    isBeta = false,
  } = props;
  return (
    <LinearGradient
      start={{x: 0, y: 0}}
      end={{x: 1, y: 1}}
      colors={[`${colors.palette.brandPink}`, `${colors.palette.brandBlue}`]}
      style={[styles.gradient, styleOverride]}>
      <ReactNativeButton
        onPress={onPress}
        disabled={disabled}
        style={styles.button}>
        {/* render icons  */}
        {icon}

        {/* text  */}
        <Text style={[styles.text, textStyleOverride]}>{title}</Text>

        {/* beta label  */}
        {isBeta ? <Text style={styles.betaLabel}>Beta</Text> : null}
      </ReactNativeButton>
    </LinearGradient>
  );
}

type styleType = {
  button: ViewStyle;
  text: TextStyle;
  gradient: ViewStyle;
  betaLabel: TextStyle;
};

const styles: styleType = StyleSheet.create({
  gradient: {
    borderRadius: corner_radius['rounded-md'],
  },
  betaLabel: {
    backgroundColor: colors.palette.yelloWarning,
    fontSize: 12,
    paddingHorizontal: spacing['1'],
    paddingVertical:2,
    borderRadius: corner_radius['rounded-sm'],
    fontWeight: 500,
  },
  button: {
    height: 40,
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing['2'],
    flexDirection: 'row',
    paddingHorizontal: spacing['3'],
  },
  text: {
    fontSize: 16,
    fontWeight: '600',
    color: colors.palette.white,
  },
});
